<div class="snackbar-content">
  <mat-icon *ngIf="data.type===SNACKBAR_TYPE.ERROR">warning</mat-icon>
  <mat-icon *ngIf="data.type===SNACKBAR_TYPE.OK">check</mat-icon>
  <div [innerHTML]="data.content"></div>
</div>
<ng-container *ngIf="data.showProgress">
  <mat-progress-bar mode="indeterminate" color="primary" style="margin-top:10px;"></mat-progress-bar>
</ng-container>
